export default function handleUsedVehiclesDefaultSort(props, store, callback) {
  const { channelUsedVehiclesSort } = props;
  if (!channelUsedVehiclesSort) return;

  const { filtersList } = store.getState();
  const hasSortActiveFilters = filtersList.some(filter => 'sort' in filter);

  if (hasSortActiveFilters) return;

  callback();
}
